module.exports = __webpack_public_path__ + "static/media/lockedOnCards.4638df4a.svg";